// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 78849, offsets 507235:507317. Structure and names inferred from code, not screenshots.

const announcementUrl = "https://mimo.xiaomimimo.com/desktop/";
export { announcementUrl };
